export function archiveColumnSoftware(header) {
  const name = String(header || "").toUpperCase();
  if (!name.includes("COD. CONTO") && !name.includes("DESCRIZIONE")) {
    return "";
  }
  if (name.includes("TEAMSYSTEM") || name.includes("TEAM SYSTEM")) {
    return "TEAMSYSTEM";
  }
  if (name.includes("DATEV")) return "DATEV";
  if (name.includes("ZUCCHETTI")) return "ZUCCHETTI";
  if (name.includes("SEAC")) return "SEAC";
  if (name.includes("SISTEMI")) return "SISTEMI";
  return "";
}

export function isArchiveColumnVisible(headers, index, selectedSoftware) {
  const header = String(headers?.[index] || "").trim();
  if (header.toUpperCase() === "ID ASSOCIAZIONE") return false;
  if (selectedSoftware === "ALL") return true;
  const software = archiveColumnSoftware(header);
  return !software || software === selectedSoftware;
}
